import { useMemo } from 'react';
import useGetTechnicians from '@hooks/requests/technicians.get.hook';
import useGetSubcontractors from '@hooks/requests/subcontractors.get.hook';
import useApiQuery from '@hooks/api-params.hook';
import TechnicianSortableAttributes from '@enums/sortable-attributes/technician-sortable-attributes.enum';
import SubcontractorSortableAttributes from '@enums/sortable-attributes/subcontractor-sortable-attributes.enum';
export function useAssigneeOptions(buildingId, subcontractorsEnabled) {
    const techniciansQuery = useMemo(() => ({
        select: 'all',
        sort: { attribute: TechnicianSortableAttributes.NAME, direction: 'asc' },
        filter: { forInspections: true, buildingId: buildingId || undefined }
    }), [buildingId]);
    const { apiParams: technicianApiParams } = useApiQuery(techniciansQuery);
    const { data: technicians } = useGetTechnicians(technicianApiParams);
    const subcontractorsQuery = useMemo(() => ({ select: 'all', sort: { attribute: SubcontractorSortableAttributes.NAME, direction: 'asc' } }), []);
    const { apiParams: subcontractorApiParams } = useApiQuery(subcontractorsQuery);
    const { data: subcontractors } = useGetSubcontractors(subcontractorApiParams, subcontractorsEnabled);
    const technicianOptions = useMemo(() => technicians.map((t) => ({ value: t.id, label: t.name })), [technicians]);
    const subcontractorOptions = useMemo(() => subcontractors.map((s) => ({ value: s.id, label: s.name })), [subcontractors]);
    return { technicianOptions, subcontractorOptions };
}
